export default __webpack_public_path__ + "assets/ico_booking_today-85a5ef07.svg";